// Copyright ©️ 2026 eVolve MEP, LLC

import type { HexTriplet } from '@evolvemep/api-ts';
import { Button } from '@mantine/core';

import { LicenseIcon } from 'assets/icons/LicenseIcon';
import { EvolveProductCard } from 'modules/Admin/Licenses/LicensesMantine/EvolveProductCard';

const SSO_LEARN_MORE_LINK = 'https://evolvemep.com/professional';

// SSO is an oddball - it's not a product, but we're wanting to show it along with the other products.
export const SSOCard = ({ active }: { active?: boolean }) => (
  <EvolveProductCard
    icon={<LicenseIcon icon="ProductSSO" color={'#00C3C3' as HexTriplet} />}
    title="SSO"
    endSection={
      active ? undefined : (
        <Button variant="light" component="a" href={SSO_LEARN_MORE_LINK} target="_blank">
          Learn more
        </Button>
      )
    }
  />
);
